import { createDictionaryApiFactory, mapDictionaryState } from "./dictionaryApiFactory";
import { fetchApi } from "../../../../lib/fetchApi";
import { SelectItemDto } from "../../../../types/SelectItemDto";

export const mapToDemandDerivation = mapDictionaryState;

const demandDerivationApi = createDictionaryApiFactory("demandDerivation");

export const getDemandDerivation = demandDerivationApi.search;
export const getDemandDerivationDetail = demandDerivationApi.getDetail;
export const createDemandDerivation = demandDerivationApi.save;
export const exportCsvDemandDerivation = demandDerivationApi.exportCsv;

export const getDemandDerivationSelect = async (): Promise<SelectItemDto[]> => {
    const response = await fetchApi.get(`/demandDerivation/select`) as SelectItemDto[];
    return response;
};
